// get list of payment method types and possible details

import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { PayInMethodType, PaymentMethodDetail } from './types';

type Response = {
  methodTypes: Array<{
    type: PayInMethodType;
    detail: PaymentMethodDetail;
  }>;
};

export default (makeCall: MakeCall) => () =>
  makeCall<Response>('GET', `/api/v2/payment/method-types`);
